import { ValueGetterParams } from "ag-grid-community";
import { ReportsTableData } from "@/store/reports/utils/types/types";
import { formatDate } from "@/utils/helpers/date-time/datetime-format";

export const reportsNextExecutionValueGetter = ({
  data,
}: ValueGetterParams<ReportsTableData>) =>
  data?.next_execution_date
    ? formatDate(data.next_execution_date, {
        type: "dateWithComma",
      })
    : undefined;
